/**
 * components/hazard/SourceIcon.js — бүртгэл ХААНААС ирснийг ялгах тэмдэг.
 *
 * `source` нь баазад анхнаасаа хадгалагддаг: вэб `"web"` илгээдэг, гар утас
 * илгээдэггүй тул анхдагч нь `"mobile"`.
 *
 * ⚠ FontAwesome 5.3.1 — `fa-mobile-alt` нь FA6-гийнх, энд БАЙХГҮЙ.
 *   `fa-mobile-alt` / `fa-desktop` хоёрыг тэр багцаас шалгасан.
 *
 * Өмнө нь hazard/Dashboard.js дотор л байсан тул зөрчлийн жагсаалтад
 * (incident/register → /inspection/register) дахин ашиглах боломжгүй байв.
 */
import React from "react";

const GREEN = "#1B7A45";

export default function SourceIcon({ source, size = 11, withLabel = false }) {
  const src = String(source || "mobile");
  // ⚠ ХУУЧИН СИСТЕМЭЭС ХӨРВҮҮЛСЭН мөр. Урьд нь «mobile» биш бүхнийг
  //   «Вэб» гэж үздэг байсан тул хөрвүүлсэн бүртгэл «вэбээс бүртгэсэн»
  //   гэж ХУДАЛ харагдана. Хуучин дата гэдгийг ялгах нь чухал:
  //   талбарууд дутуу (хүндрэлийн зэрэг, зураг г.м.) байж болно.
  const legacy = src === "legacy";
  const mobile = src === "mobile";
  const label = legacy ? "Хуучин" : mobile ? "Гар утас" : "Вэб";
  const title = legacy
    ? "Хуучин зөрчлийн бүртгэлээс хөрвүүлсэн"
    : mobile
      ? "Гар утаснаас бүртгэсэн"
      : "Вэбээс бүртгэсэн";
  const color = legacy ? "#B45309" : mobile ? GREEN : "#8A94A6";
  const icon = legacy
    ? "fa-archive"
    : mobile
      ? "fa-mobile-alt"
      : "fa-desktop";

  if (!withLabel) {
    return (
      <i
        className={"fas " + icon}
        title={title}
        style={{ fontSize: size, color, flexShrink: 0 }}
      />
    );
  }
  return (
    <span
      title={title}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontSize: size,
        color,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      <i className={"fas " + icon} />
      {label}
    </span>
  );
}
